function requireAll(r) { r.keys().forEach(r); }

requireAll( require.context( './ico/', true ) );
requireAll( require.context( './svg/', true, /\.svg$/) );
requireAll( require.context( './fonts/', true ) );
requireAll( require.context( './admin-thumbs/', true, /\.png$/) );
//requireAll( require.context( './png/', true, /\.png$/) );
//requireAll( require.context( './gif/', true, /\.gif$/) );

import $ from 'jquery';

window.jQuery = $;
window.$ = $;

import Swiper from 'swiper';
import { Scrollbar,FreeMode,Pagination,Mousewheel,Autoplay } from 'swiper/modules';

import tabsList from '../../../../../vendor/tabsspaces/tabslist/src/assets/tabsList.js';

import { gsap, Linear } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
import { ScrollToPlugin } from "gsap/ScrollToPlugin.js";

gsap.registerPlugin( ScrollToPlugin );
gsap.registerPlugin( ScrollTrigger );

import lottie from 'lottie-web';

import Plyr from 'plyr';

$(function () {

	var PROJECT = {

		common: {

			getViewport: function() {

				var viewPortWidth;
				var viewPortHeight;

				if (typeof window.innerWidth !== 'undefined') {

					viewPortWidth = window.innerWidth;
					viewPortHeight = window.innerHeight;

				} else if ( typeof document.documentElement !== 'undefined' &&
							typeof document.documentElement.clientWidth !== 'undefined' &&
							document.documentElement.clientWidth !== 0 ) {

					viewPortWidth = document.documentElement.clientWidth;
					viewPortHeight = document.documentElement.clientHeight;

				} else {

					viewPortWidth = document.getElementsByTagName('body')[0].clientWidth;
					viewPortHeight = document.getElementsByTagName('body')[0].clientHeight;
				}

				return { width : viewPortWidth , height : viewPortHeight };

			},

			init: function () {
  
                window.tabsList.init();

				PROJECT.nav.init();

				PROJECT.toggle.init();

				PROJECT.gform.init();

				PROJECT.list.init();

				PROJECT.header.init();

				PROJECT.carousels.init();

				PROJECT.video.init();

				PROJECT.lottie.init();

				PROJECT.scroll.init();

				PROJECT.scrollDetection.init();

				PROJECT.scrollIndicator.init();

				PROJECT.faq.init();
  
                window.tabsList.init();

			}

		},

		toggle: {

			/*
			 * Toggle Text in Button label
			 * Used in jsnNavToggle
			 */

			clickElm: '.jsToggleText',
			labelElm: '.jsToggleTextLabel',
			dataAttr: 'toggle-text',

			init: function() {

				$( document ).on( 'click', PROJECT.toggle.clickElm, PROJECT.toggle.switch );

			},

			switch: function( e ) {

				let $elm =  $( this );

				let $label = $elm.find( PROJECT.toggle.labelElm );

				let toggleText = $elm.data( PROJECT.toggle.dataAttr );

				let currentText = $label.text();

				let newText = currentText == toggleText.current ? toggleText.toggle : toggleText.current;

				$label.text( newText );

				$elm.attr( 'title', newText );

			}

		},

		nav: {

			/*
			 * Toggle Core Nav Visibility
			 * - Sets a css class on html elmement
			 * - Disable tabsindex when menu is closed
			 * - Click and Key controlled
			 */


			mainElm: '.navMain',
			clickElm: '.jsNavToggle',
			openClass: 'state-c-nav--nav-open',


			init: function() {

				$( document ).on( 'click', PROJECT.nav.clickElm, PROJECT.nav.toggle );

				$( document ).on( 'keyup', PROJECT.nav.esc );

				$( PROJECT.nav.mainElm + ' a' ).each( function() {

					$( this ).attr('tabindex', -1 );

				});

			},

			toggle: function() {

				if ( $( 'html' ).hasClass( PROJECT.nav.openClass ) ) {

					PROJECT.nav.close();

				} else {

					PROJECT.nav.open();
				}
			},

			esc: function( e ) {

				if ( e.keyCode === 27 ) {

					PROJECT.nav.close();

				}
			},

			open: function() {

				$( 'html' ).addClass( PROJECT.nav.openClass );

				$( PROJECT.nav.mainElm + ' a').each( function() {

					$( this ).removeAttr('tabindex', -1 );

				});

			},

			close: function() {

				$( 'html' ).removeClass( PROJECT.nav.openClass );

				$( PROJECT.nav.mainElm  + ' a' ).each( function() {

					$( this ).attr('tabindex', -1 );

				});

			}


		},

		gform: {

			init: function() {

				$( document ).on( 'gform_post_render', PROJECT.gform.hideLoader );

				$( document ).on( 'click.loader', '.gform_button', PROJECT.gform.showLoader );
				$( document ).on( 'click.loader', '.gform_next_button, gform_previous_button', PROJECT.gform.showLoader );
				$( document ).on( 'submit', '.gform_wrapper form', PROJECT.gform.showLoader );

				$( document ).on( 'gform_page_loaded', PROJECT.gform.hideLoader );

				$( document ).on( 'gform_confirmation_loaded', PROJECT.gform.showConfirmation );
				$( document ).on( 'click.loader', '.gformCloseConfirmation', PROJECT.gform.hideConfirmation );


				$( document ).on( 'focus', 'input, textarea, select', function() {
					$( this ).parents( '.gfield' ).addClass( 'state--has-focus' );
				});

				$( document ).on( 'blur', 'input, textarea, select', function( e ) {
					if( !$(this).val() ) {
						$( this ).parents( '.gfield' ).removeClass( 'state--has-focus' );
					}
				});

				PROJECT.gform.fixHasFocus();

			},

			fixHasFocus: function() {

				$( 'input, textarea, select' ).each(function() {

					if( $(this).val() ) {
						$( this ).parents( '.gfield' ).addClass( 'state--has-focus' );
					}

				});

			},

			showLoader: function() {

				var $gformContainer = $(this).closest( '.gformContainer' );
				var $gformLoader = $gformContainer.find( '.gformLoader' );

				$gformLoader.fadeIn( 300 ).css( 'display', 'flex' );

			},

			hideLoader: function() {

				$( '.gformLoader' ).fadeOut( 300 );
				PROJECT.gform.fixHasFocus();

			},

			showConfirmation: function() {

				$( '.gformConfirmation' ).fadeIn( 300 ).css( 'display', 'flex' );

			},

			hideConfirmation: function() {

				$( '.gformConfirmation' ).fadeOut( 300 );

			}

		},

		list: {

			// Only for project based code.
			init:function() {}

		},

		header: {

			init: function() {

				PROJECT.header.getHeight( '.jsSiteHeader','--header-site-height');

				window.onresize = function() {

					PROJECT.header.getHeight( '.jsSiteHeader','--header-site-height');

				}

			},

			getHeight: function( targetClass,cssVariable ) {

				var $this = $(targetClass);

				if( $this.length > 0 ) {

					$( 'html' ).css( cssVariable,$this.outerHeight());

				}

			}

		},

 		carousels: {

			init: function() {

				PROJECT.carousels.blocks();
				PROJECT.carousels.infoBlocks();
				PROJECT.carousels.blockLinks();

			},

			blocks: function() {

				var carousels = document.querySelectorAll('.jsBlocksCarousel');

				if ( typeof carousels === 'object' && carousels.length > 0 ) {

					carousels.forEach((carousel, index) => {
						
						const carouselContainer = carousel.querySelector( '.jsCarousel' );
						const scrollBarContainer = carousel.querySelector( '.jsCarouselScrollbarContainer' );
						const scrollBarElm = carousel.querySelector( '.jsCarouselScrollbar' );
						const scrollBarElmDrag = carousel.querySelector( '.jsCarouselScrollbarDrag' );

						const swiper = new Swiper( carouselContainer, {
							
							modules: [Scrollbar,FreeMode,Mousewheel],

							slidesPerView: 1,

							freeMode: true,

							spaceBetween: 16,

							mousewheel: true,

							watchOverflow:true,
							centerInsufficientSlides: true,

							scrollbar: {
								el: scrollBarElm,
								hide: false,
								draggable: true,
								snapOnRelease: false,
								dragSize: scrollBarElmDrag.offsetWidth,
								dragClass:'jsCarouselScrollbarDrag',
							},

							breakpoints: {
							
								768: {

									slidesPerView: 2,
								  	spaceBetween: 25
									
								},
								996: {

									slidesPerView: 4,
									spaceBetween: 40

								},

							},

							on: {

								lock: function () {
								
								  	scrollBarContainer.setAttribute('style', 'display:none');

								},

								unlock: function () {
								
									scrollBarContainer.setAttribute('style', 'display:block');

							  },

							}
							
						});

					});

				}

			},

			infoBlocks: function() {

				var carousels = document.querySelectorAll('.jsInfoBlocksCarousel');

				if ( typeof carousels === 'object' && carousels.length > 0 ) {

					carousels.forEach((carousel, index) => {

						const carouselContainer = carousel.querySelector( '.jsCarousel' );
						const pager = carousel.querySelector( '.jsCarouselBullets' );

						const swiper = new Swiper( carouselContainer, {
							
							modules: [Pagination,Autoplay],

							slidesPerView: 1,

							spaceBetween: 0,

							autoplay: {
								delay: 5000,
							},

							pagination: {

								el: pager,
								clickable: true,

							},
							
						});

					});

				}

			},

			blockLinks: function() {

				var carousels = document.querySelectorAll( '.jsBlockLinks' );

				if ( typeof carousels === 'object' && carousels.length > 0 ) {

					carousels.forEach((carousel, index) => {

						const pager = carousel.querySelector( '.jsBlockLinksPager' );

						const swiper = new Swiper( carousel, {
							
							modules: [Pagination,Autoplay],

							slidesPerView: 1,

							direction: 'vertical',

							spaceBetween: 0,

							autoplay: {
								delay: 5000,
							},

							pagination: {

								el: pager,

								clickable: true,

								bulletClass: 'v-block-link__page',
								bulletActiveClass: 'v-block-link__page--active'

							},
							
						});

					});

				}

			},

		},

		video: {

			init: function() {

				var players = document.querySelectorAll('.jsVideoWrapper');

				if ( typeof players === 'object' && players.length > 0 ) {

					players.forEach((playerTarget, index) => {

						var $target = playerTarget.querySelector('.jsVideo');
	
						const controls =  $target.hasAttribute('controls') ? true : false;
						const autoplay =  $target.hasAttribute('autoplay') ? true : false;
						const muted =  $target.hasAttribute('muted') ? true : false;
						const loop =  $target.hasAttribute('loop') ? true : false;

						const clickToPlay =  $target.hasAttribute('autoplay') ? false : true;
						const volume =  $target.hasAttribute('muted') ? 0 : 0.5;

						const player = new Plyr($target, {

							clickToPlay: clickToPlay,
							muted: muted,
							volume: volume,
							autoplay:autoplay,
							loop:{ active: loop },
							controls: controls ? ['play',  'progress', 'volume', 'mute','fullscreen'] : [], //['play', 'progress', 'current-time', 'mute', 'volume', 'captions', 'settings', 'pip', 'airplay', 'fullscreen'],
							hideControls: false,
							fullscreen: {
								enabled: true,
								fallback: true,
								iosNative: true
							},
							playsinline: true,
							vimeo: {
								playsinline: true,
								loop:true
							},
							youtube: {
								playsinline: true,
								loop:true
							},

						});

						player.on('ready', (event) => {

							if(autoplay === true) {

								player.play();
	
							}

						});

						player.on("play", (event) => {

							playerTarget.classList.add('jsVideoPlaying');
	
						});

						player.on("pause", (event) => {

							playerTarget.classList.remove('jsVideoPlaying');
	
						});

						
						
					})

				}

			},
 
		},

		lottie: {

			array: [],

			init: function () {

				$( '.jsLottieAnim' ).each( function( index, value ) {

					var element = this;

					PROJECT.lottie.initPerAnimation( index, element );

				});

			},

			initPerAnimation: function( index, element ) {

				// set id

				$( element ).attr("data-lottie-index",index);

				// get data
				
				var jsonData = $( element ).data( 'json' );
				var loopData = $( element ).data( 'loop' );
				var autoplayData = $( element ).data( 'autoplay' );

				if ( loopData === undefined || loopData == 'undefined' || loopData == null ) {

					loopData = true;

				}

				if ( autoplayData === undefined || autoplayData == 'undefined' || autoplayData == null ) {

					autoplayData = true;

				}
				
				var lottieObject = lottie.loadAnimation({
					
					container: element,
					renderer: 'svg',
					loop: loopData,
					autoplay: autoplayData,
					path: jsonData

				});

				// console.log( lottieObject );

				// lottieObject.addEventListener('data_ready', function() {

				// 	ScrollTrigger.refresh();

				// })
				
				PROJECT.lottie.array.push( lottieObject );

			}

		},

		scrollDetection: {

			htmlEl: document.querySelector('html'),
			headerEl: document.querySelector('.jsSiteHeader'),
			isInit: true,

			init: function() {

				let oldValue = 0;
				let newValue = 0;
				let offsetTop = 30;
				let offsetScroll = 30;
				let scrollTimeout = false;

				PROJECT.scrollDetection.updateClasses(window.pageYOffset, 0, offsetTop);

				window.addEventListener('scroll', (e) => {

					if( PROJECT.scrollDetection.headerEl !== null ) {

						offsetTop = PROJECT.scrollDetection.headerEl.offsetHeight + 50;

					}

					newValue = window.pageYOffset;
					let difference = Math.abs(newValue - oldValue);
					
					if ( (difference >= offsetScroll) || newValue <= offsetTop ) {

						clearTimeout(scrollTimeout);
						PROJECT.scrollDetection.updateClasses(newValue, oldValue, offsetTop);
						oldValue = newValue;

					} else if ( newValue > offsetTop ) {

						PROJECT.scrollDetection.updateClasses(newValue, oldValue, offsetTop);

					} else {

						scrollTimeout = setTimeout(function(){
							oldValue = newValue;
						}, 500);

					}
					
				});

			},

			updateClasses: function(newValue, oldValue, offsetTop) {

				let htmlEl = PROJECT.scrollDetection.htmlEl;

				if ( newValue <= offsetTop ) {

					htmlEl.classList.remove('state--scroll-up');
					htmlEl.classList.remove('state--scroll-down');

					if (!htmlEl.classList.contains('state--scroll-at-top')) {
						htmlEl.classList.add('state--scroll-at-top');
					}
					if (htmlEl.classList.contains('state--scroll-not-at-top')) {
						htmlEl.classList.remove('state--scroll-not-at-top');
					}

				} else {

					if (htmlEl.classList.contains('state--scroll-at-top')) {
						htmlEl.classList.remove('state--scroll-at-top');
					}
					if (!htmlEl.classList.contains('state--scroll-not-at-top')) {
						htmlEl.classList.add('state--scroll-not-at-top');
					}

					if (oldValue < newValue) {
						
						if (!htmlEl.classList.contains('state--scroll-down')) {
							htmlEl.classList.remove('state--scroll-up');
							htmlEl.classList.add('state--scroll-down');
						}

					} else if (oldValue > newValue) {
						
						if (!htmlEl.classList.contains('state--scroll-up')) {
							htmlEl.classList.add('state--scroll-up');
							htmlEl.classList.remove('state--scroll-down');
						}

					}

				}

			}

		},

		scrollIndicator: {

			init: function() {

				window.addEventListener('scroll', (e) => {

					PROJECT.scrollIndicator.onScroll();

				});

			},

			onScroll: function() {

				var winScroll = document.body.scrollTop || document.documentElement.scrollTop;
				var height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
				var scrolled = (winScroll / height) * 100;

				document.querySelector(".jsScrollIndicatorCurrent").style.width = scrolled + "%";

			}

		},

		faq: {

			init: function() {

				$( document ).on( 'click', '.jsFaqQuestionToggle', {

					class: 's-faq__question--open',
					classElement: '.jsFaqQuestionContainer',
					toggleElement: '.jsFaqQuestionText',

				}, PROJECT.faq.toggle );

				$( document ).on( 'keyup change', '.jsFaqSearchInput', PROJECT.faq.search );
				$( document ).on( 'submit', '.jsFaqSearchForm', PROJECT.faq.search );

			},

			getParent: function( e ) {

				var $parent = $( e ).closest( '.jsFaqSection' ); 

				return $parent;

			},

			toggle: function ( e ) {

				e.preventDefault();

				var parent = $( this ).closest( e.data.classElement );

				if ( !$( parent ).hasClass( e.data.class ) ) {

					$( parent ).addClass( e.data.class );

					if ( e.data.toggleElement !== '' ) {

						$( parent ).find( e.data.toggleElement ).slideDown( 250 );

					}

				} else {

					$( parent ).removeClass( e.data.class );

					if ( e.data.toggleElement !== '' ) {

						$( parent ).find( e.data.toggleElement ).slideUp( 250 );

					}

				}

			},

			search: function( e ) {

				e.preventDefault();

				var $parent = PROJECT.faq.getParent( this );

				var searchValue = $parent.find( '.jsFaqSearchInput' ).val().toUpperCase();

				// search within all faq items

				var faqItemsTotal = 0;

				$parent.find( '.jsFaqCategoryContainer' ).each( function( i ) {

					var faqContainer = $( this );
					var faqItems = $( this ).find( '.jsFaqQuestionContainer' );
					var faqItemsLength = faqItems.length;

					faqItems.each( function( i ) {

						var faqText = $( this ).text();
						
						if ( faqText.toUpperCase().indexOf( searchValue ) > -1 ) {

							faqItemsTotal++;

							$( this ).show();

						} else {

							faqItemsLength -= 1;

							$( this ).hide();
							
						}

					});

					if ( faqItemsLength == 0 ) {

						$( faqContainer ).hide();

					} else {

						$( faqContainer ).show();

					}

				});

				if ( searchValue == '' ) {

					$( '.jsFaqSearchResults' ).removeClass( 's-faq__results--show' );

				} else {

					$( '.jsFaqSearchResults' ).addClass( 's-faq__results--show' );
					$( '.jsFaqSearchResults' ).find( 'span' ).text( faqItemsTotal );

				}

			}

		},

		scroll: {

			init: function() {

				$( window ).on( 'resize orientationchange', ScrollTrigger.refresh() );

				PROJECT.scroll.addlottieOnScroll();

			},

			addlottieOnScroll: function() {

				var lotties = gsap.utils.toArray( '.jsLottieAnim' );
				
				lotties.forEach( ( lottie ) => {

					var lottieIndex = $( lottie ).attr( 'data-lottie-index' );
					
					var start = 'top center';

					gsap.timeline({

						scrollTrigger: {

							trigger: lottie,
							start: "top center",
							end: "bottom center",

							onEnter: ({progress, direction, isActive}) => {

								PROJECT.lottie.array[lottieIndex].play();

							},


						}

					});

				});

			},

		}

	};

	var UTIL = {

		exec: function (controller, action) {

			var ns = PROJECT;
			action = (action === undefined) ? 'init' : action;

			if (controller !== '' && ns[controller] && typeof ns[controller][action] === 'function') {

				ns[controller][action]();

			}

		},

		init: function () {

			var body = document.body,
				controller = body.getAttribute('data-controller'),
				action = body.getAttribute('data-action');

			UTIL.exec('common');
			UTIL.exec(controller);
			UTIL.exec(controller, action);

		}

	};

	//$.PROJECT = PROJECT; // Make global available

	$(window).ready(UTIL.init);

});

